import { Button, Grid } from "@mui/material";
import React, { useState } from "react";
import {
  GridContextProvider,
  GridDropZone,
  GridItem,
  swap,
  move,
} from "react-grid-dnd";
import reportbuilder from "../ReportBuilder.module.css";
import { useSelector, useDispatch } from "react-redux";
import { setReportVal } from "../../../reduxStore/reducer.js";
import DropValues from "./DropValues.jsx";

const ReportValues = () => {
  const dispatch = useDispatch();
  const items = useSelector((state) => state.selectedDimensions.reportVal);
  console.log("items", items[0]);

  const addHandeler = (clickedObj) => {
    let newBottomArr = [...items[0].reportBottom, clickedObj];
    console.log("newBottomArr...", newBottomArr);
    const newReportTopArr = items[0].reportTop.filter(
      (item) => item.id !== clickedObj.id
    );
    console.log("items inside handler fun", items);
    dispatch(
      setReportVal([
        {
          ...items[0],
          ["reportBottom"]: newBottomArr,
          ["reportTop"]: newReportTopArr,
        },
      ])
    );
  };

  return (
    <Grid
      className="reportvalBoxRB"
      xs={12}
      sx={{ display: "block", height: "17vh" }}
    >
      <p className={reportbuilder.headers}>Report Values</p>

      <div className={reportbuilder.dropzone}>
        {" "}
        <GridDropZone
          className="dropzone"
          id="reportTop"
          boxesPerRow={5}
          rowHeight={40}
          sx={{ overflow: "hidden" }}
          // spacing={2}
        >
          {items[0].reportTop.map((item) => (
            <GridItem style={{ zIndex: 100, width: "auto" }}
              key={item.name}
            >
              <Button
                className={reportbuilder.gridcontent}
                sx={{
                  bgcolor: "#F3F8FC",
                  color: "#000",
                  fontSize: "12px",
                  fontWeight: "900 !important",
                }}
                key={item.id}
                onClick={() => {
                  addHandeler(item);
                }}
              >
                <span>+</span>
                <span>{item.name}</span>
              </Button>
            </GridItem>
          ))}
        </GridDropZone>
      </div>
      {/* <DropValues/> */}
    </Grid>
  );
};

export default ReportValues;
